// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__ZmPt9","sliderDark":"Slider_sliderDark__LXCe2","sliderYellow":"Slider_sliderYellow__Q4jge"};